function TrashGreyIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} viewBox="0 0 40 40" {...props}>
      <g data-name="Group 53986" transform="translate(-.428)">
        <rect width={40} height={40} rx={4} transform="translate(.428)" fill="#ecf0f1" />
        <g data-name="Group 55206" transform="translate(11.427 12)" fill="none" stroke="#263238" strokeWidth={1.4}>
          <path data-name="Path 12831" d="M5.839 2.709a3.2 3.2 0 016.322 0" strokeLinejoin="round" />
          <path data-name="Path 12832" d="M2.375 2.447V16h13.248V2.447" />
          <path data-name="Line 330" transform="translate(0 3.195)" d="M0 0L18 0" />
          <path data-name="Line 421" transform="translate(5.85 7.458)" d="M0 0L0 5.234" />
        </g>
      </g>
    </svg>
  )
}

export default TrashGreyIcon
